import { useState } from "react";

export default function SolutionsSection() {
  const [isPlaying, setIsPlaying] = useState(false);

    return (
      <section className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between px-8 py-16 bg-white">
        {/* Image Section */}
        <div className="md:w-1/2 flex justify-center mt-8 md:mt-0">
      {isPlaying ? (
        <iframe
          className="w-full max-w-md md:max-w-lg aspect-video"
          src="https://www.youtube.com/embed/BoyJWVTIvgI?autoplay=1"
          title="Period Tracker App Video"
          allow="autoplay; encrypted-media"
          allowFullScreen
        ></iframe>
      ) : (
        <button onClick={() => setIsPlaying(true)}>
          <img
            src="/images/video-thumb.png"
            alt="Period Tracker App"
            className="w-full max-w-md md:max-w-lg cursor-pointer border-4 border-[#679729] rounded-lg"
            />
        </button>
      )}
    </div>


        {/* Text Section */}
        <div className="md:w-1/2 text-left">
          <h2 className="text-[#679729] text-2xl font-bold">
            Eco-Friendly & Biodegradable Sanitary Pads
          </h2>
          <p className="text-gray-600 mt-4">
            Our mission is to provide a sustainable and healthier alternative for menstrual care. Made from 100% organic cotton, our biodegradable sanitary pads offer superior comfort and protection without exposing your skin to harsh chemicals. Designed for eco-conscious women, these pads decompose naturally, reducing waste and promoting a greener planet. Experience a healthier period while making a positive impact on the environment.
          </p>
        </div>

        
       
      </section>
    );
  }
  